import { Component, Inject, OnInit, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { LanguageService } from '@shared/services/language.service';
import { TooltipDialogData } from '@shared/components/tooltip-dialog/TooltipDialogData';

@Component({
  selector: 'app-tooltip-dialog',
  templateUrl: './tooltip-dialog.component.html',
  styleUrls: ['./tooltip-dialog.component.scss']
})
export class TooltipDialogComponent implements OnInit {

  data: TooltipDialogData;
  lang$: Observable<string>;

  constructor(
    public dialogRef: MatDialogRef<TooltipDialogComponent>,
    public languageService: LanguageService,
    @Inject(MAT_DIALOG_DATA) data: TooltipDialogData) {
      this.data = data;
  }

  ngOnInit() {
    this.lang$ = this.languageService.languageType$;
  }

  close(): void {
    this.dialogRef.close();
  }

  @HostListener('window: keyup.esc') onKeyUp() {
    this.close();
  }
}
